import React from 'react'
import Modal from 'new-components/Modal'
import Button from 'new-components/Button'

interface PrescriptionRequiredModalProps {
  isOpen: boolean
  onClose: () => void
  onNoPrescription: () => void
  hasControlledItems?: boolean
  allControlledItems?: boolean
  isPillOnly?: boolean
}

const SINGLE_PRESCRIPTION_TEXT = {
  title: 'Para adquirir este medicamento, é obrigatória a apresentação de receita médica.',
  description:
    'A compra só será concluída mediante o envio da prescrição emitida por um profissional habilitado. Certifique-se de ter sua receita em mãos antes de finalizar o pedido.'
}

const getModalTexts = (hasControlledItems?: boolean, allControlledItems?: boolean, isPillOnly?: boolean) => {
  if (isPillOnly) {
    return SINGLE_PRESCRIPTION_TEXT
  }

  if (allControlledItems) {
    return SINGLE_PRESCRIPTION_TEXT
  }

  if (hasControlledItems) {
    return {
      title:
        'Para adquirir estes medicamentos — à base de cannabis medicinal e de controle especial — é obrigatória a apresentação das receitas médicas.',
      description:
        'A compra só será concluída mediante o envio das prescrições emitidas por um profissional habilitado, incluindo a receita específica do medicamento de controle especial. Certifique-se de ter suas receitas em mãos antes de finalizar o pedido.'
    }
  }

  return {
    title:
      'Para adquirir este medicamento à base de cannabis medicinal, é obrigatória a apresentação de receita médica.',
    description:
      'A compra só será concluída mediante o envio da prescrição emitida por um profissional habilitado. Certifique-se de ter sua receita em mãos antes de finalizar o pedido.'
  }
}

export const PrescriptionRequiredModal: React.FC<PrescriptionRequiredModalProps> = ({
  isOpen,
  onClose,
  onNoPrescription,
  hasControlledItems,
  allControlledItems,
  isPillOnly
}) => {
  const { title, description } = getModalTexts(hasControlledItems, allControlledItems, isPillOnly)

  return (
    <Modal isOpen={isOpen} setOpenModal={onClose}>
      <div className="flex min-h-[319px] w-[539px] flex-col gap-4 rounded sm:min-h-0 sm:w-[calc(100%-32px)] sm:max-w-[calc(100%-32px)] sm:px-6 sm:py-6 md:min-h-0 md:w-full md:max-w-[539px] md:px-4 md:py-4">
        <h2 className="font-poppins text-left text-lg font-semibold leading-[140%] text-[#6B7B3C]">{title}</h2>
        <div className="flex flex-1 flex-col gap-6">
          <p className="font-poppins text-left text-sm font-normal leading-[140%] text-[#898483]">{description}</p>
          <div className="flex items-center gap-4">
            <button
              onClick={onClose}
              className="cursor-pointer border-0 bg-transparent px-4 py-2 text-base font-medium text-[#6C8640] transition-colors hover:text-[#5a6b2f]">
              Sim, possuo receita
            </button>
            <Button onClick={onNoPrescription} background="primary" height={44}>
              Não possuo receita
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  )
}
